import React from 'react';
import { Navigate, Outlet, useOutletContext } from 'react-router-dom';
import { usePermissions } from '../hooks/usePermissions';

interface PermissionRouteProps {
  section: string;
  fallbackPath: string;
}

export const PermissionRoute: React.FC<PermissionRouteProps> = ({ section, fallbackPath }) => {
  const { hasSectionPermission } = usePermissions();
  const context = useOutletContext();

  // Verificar si el usuario tiene permiso para esta sección
  if (!hasSectionPermission(section)) {
    console.warn(`[PermissionRoute] Access denied to section: ${section}`);
    return <Navigate to={fallbackPath} />;
  }

  return <Outlet context={context} />;
}; 